<template>
  <el-row v-bind="$props">
    <slot />
  </el-row>
</template>

<script>
export default {
  name: 'RtRow',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    gutter: {
      type: Number,
      default: 32
    },
    type: String,
    justify: {
      type: String,
      default: 'start'
    },
    align: {
      type: String,
      default: 'top'
    }
  },
  provide () {
    return {
      rtRow: this
    };
  }
};
</script>



// WEBPACK FOOTER //
// rtRow.vue?3c247c3d